import { Controller } from "@hotwired/stimulus"

const MESSAGE_READY = "fp:ready"
const MESSAGE_VIEW_SHOWN = "fp:viewShown"
const VIEW_3D = "3d"
const BLANK = "about:blank"
const LIVE_CLASS = "lp-start__preview--live"

// The first screen of the Layout tab (a tent or a venue?). Each half shows its plan live, in 3D, slowly turning: a frame of the floorplans
// embed, which the page tells to open in 3D, to take its roof off and to circle (`fp:setViewOptions`). A frame fades in once 3D is showing.
// The frames are only loaded while this screen is: the planner stops them when a flow starts (a 3D scene is not free), and starts them again
// on "Start over". They are for looking at, so they take no clicks and the card over them stays the button.
export default class extends Controller {
  static targets = ["frame"]
  static values = { floorplansOrigin: String }

  connect() {
    this.onMessage = (event) => this.receive(event)
    window.addEventListener("message", this.onMessage)
    this.reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches
    this.start()
  }

  disconnect() {
    window.removeEventListener("message", this.onMessage)
  }

  start() {
    this.frameTargets.forEach((frame) => { if (frame.getAttribute("src") !== frame.dataset.src) frame.src = frame.dataset.src })
  }

  stop() {
    this.frameTargets.forEach((frame) => {
      frame.src = BLANK
      frame.parentElement.classList.remove(LIVE_CLASS)
    })
  }

  receive(event) {
    if (event.origin !== this.floorplansOriginValue) return

    const frame = this.frameTargets.find((candidate) => candidate.contentWindow === event.source)
    if (!frame) return

    if (event.data.type === MESSAGE_READY) this.show3d(frame)
    if (event.data.type === MESSAGE_VIEW_SHOWN && event.data.view === VIEW_3D) frame.parentElement.classList.add(LIVE_CLASS)
  }

  // Roof off, so the inside can be seen, and a slow turn (none for a visitor who has asked for less motion).
  show3d(frame) {
    const post = (type, payload) => frame.contentWindow.postMessage({ type, ...payload }, this.floorplansOriginValue)
    post("fp:setViewOptions", { canopy: "hidden", autoRotate: !this.reducedMotion })
    post("fp:setView", { view: VIEW_3D })
  }
}
